import { useRef, useState, useEffect, useContext, createContext } from 'react';
import { useLocation, Link, useNavigate } from "react-router-dom";

import { Container, Stack, Button, TextField, MenuItem } from '@mui/material';

import axios from "axios";
import dayjs from 'dayjs';

import { API, MSG } from "./constantsFront";
import { MsgContext } from '../../App';
import { Text } from 'html-react-parser';

/**
 * 質問編集
 * @returns
 */

const G0225QuestionEdit = () => {
  const navigate = useNavigate();

  const [QuestionId, setQuestionId] = useState("");                        //質問ID
  const [QuestionCategoryId, setQuestionCategoryId] = useState("");        //質問カテゴリーID
  // const [GroupId,setGroupId] = useState("");                              //関連ID
  const [ContentsQuestion, setContentsQuestion] = useState("");            //質問内容
  const [QuestionAnswer, setQuestionAnswer] = useState("");                //質問回答
  const [DisplayOrder, setDisplayOrder] = useState("");                    //表示順
  const [PublishDate, setPublishDate] = useState("");

  const [QuestionIdMsg, setQuestionIdMsg] = useState("");                  //入力チェックメッセージ(質問ID)
  const [QuestionCategoryIdMsg, setQuestionCategoryIdMsg] = useState("");  //入力値チェックメッセージ(質問カテゴリーID)
  // const [GroupIdMsg,setGroupIdMsg] = useState("");                        //入力値チェックメッセージ(関連ID)
  const [ContentsQuestionMsg, setContentsQuestionMsg] = useState("");      //入力値チェックメッセージ(質問内容)
  const [QuestionAnswerMsg, setQuestionAnswerMsg] = useState("");          //入力値チェックメッセージ(質問回答)
  const [DisplayOrderMsg, setDisplayOrderMsg] = useState("");              //入力値チェックメッセージ(表示順)
  const [PublishDateMsg, setPublishDateMsg] = useState("");

  const [QueMain, setQueMain] = useState("");                             //Edit画面表題
  const [QuestionCategoryList, setQuestionCategoryList] = useState([]);    //ドロップダウンリスト用(質問カテゴリーID)    

  const { msg, setMsg } = useContext(MsgContext);				// エラーメッセージ
  let body = { authKey: API.API_KEY };

  let select_que_id = '';   //操作内容(新規追加(値:-1)、変更(値:選択された質問カテゴリーID))を判定するid
  let questionDetail = {}

  //G0224のstateからデータを受け取る
  const location = useLocation();
  if (location.state != null) {
    select_que_id = location.state.ID;
    //ローカルストレージに保存する
    window.localStorage.setItem("select_que_id", select_que_id);
  } else {
    //ローカルストレージから取り出す
    select_que_id = window.localStorage.getItem("select_que_id");
  }

  //初回読込チェック
  const refIsFirst = useRef(true);
  useEffect(() => {
    if (!refIsFirst.current) {
      return;
    }

    //新規追加・編集による分岐
    if (select_que_id == -1) {
      setQueMain("質問新規追加");
    } else {
      getQuestion();
      setQueMain("質問編集");
    }

    //ドロップダウンリスト用(カテゴリーID)
    axios.post("/m_que_category/select/auth", body).then(res => {
      //取得チェック
      if (res.status !== 200) {
        setMsg("データを正常に取得できませんでした");
        return;
      }


      let list = res.data.categoryList
      let LIST = []
      for (let i in list) {
        LIST.push({
          category_id: list[i].category_id
          , category_name: list[i].category_name
        })
      }
      setQuestionCategoryList(LIST);
    }).catch(error => {
      console.log("error : ", error.message);
      setMsg(MSG.EXCEPTION);
    })

    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  })

  //質問取得
  async function getQuestion() {
    try {
      body.questionid = select_que_id;
      let res = await axios.post("/m_question/select/auth", body);
      if (res.status !== 200) {
        setMsg("データを正常に取得できませんでした");
        return;
      } else {
        let QList = res.data.questionList;
        setQuestionId(QList[0].question_id);
        setQuestionCategoryId(QList[0].category_id);
        // setGroupId(QList[0].group_id);                 //関連ID固定値入力のため
        setContentsQuestion(QList[0].contents_question);
        setQuestionAnswer(QList[0].question_answer);
        setDisplayOrder(QList[0].display_order);
        setPublishDate(QList[0].publish_date ? dayjs(QList[0].publish_date).format('YYYY-MM-DD HH:mm:ss') : null);
      }
    } catch (err) {
      console.log("error", err.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //入力チェック
  function ValueCheck() {
    let errCnt = 0;

    if (!PublishDate) {
      setPublishDateMsg("公開日時は必須です。");
      errCnt++;
    } else {
      setPublishDateMsg("");
    }

    if (select_que_id != -1) {                //質問IDチェック★
      if (!QuestionId) {                        //編集時のチェック
        setQuestionIdMsg("質問IDは必須です");
        errCnt++;
      } else {
        setQuestionIdMsg("");
      }
    } else {                                    //新規追加時
      setQuestionIdMsg("");
    }

    if (!QuestionCategoryId) {                //質問カテゴリーIDチェック
      setQuestionCategoryIdMsg("質問カテゴリーIDは必須です");
      errCnt++;
    } else {
      setQuestionCategoryIdMsg("");
    }


    if (!ContentsQuestion.trim()) {                  //質問内容チェック
      setContentsQuestionMsg("質問内容は必須です");
      errCnt++;
    } else {
      setContentsQuestionMsg("");
    }

    if (!QuestionAnswer.trim()) {                    //質問回答チェック
      setQuestionAnswerMsg("質問回答は必須です");
      errCnt++;
    } else {
      setQuestionAnswerMsg("");
    }

    if (DisplayOrder && !String(DisplayOrder).match(/^[+-]?([1-9][0-9]*|0)$/)) { //表示順チェック
      setDisplayOrderMsg("整数を入力してください。")
      errCnt++;
    } else {
      setDisplayOrderMsg("");
    }

    if (errCnt > 0) {
      return false;
    } else {
      return true;
    }
  };

  //保存処理
  async function register() {
    try {
      console.log("保存処理開始");

      //入力値チェック
      if (!ValueCheck()) {
        return
      };

      let csletr = {};
      csletr.question_id = QuestionId;
      csletr.category_id = QuestionCategoryId;
      csletr.group_id = 0;                      //関連ID固定値(0)入力
      csletr.contents_question = ContentsQuestion.trim();
      csletr.question_answer = QuestionAnswer.trim();
      csletr.display_order = DisplayOrder == '' ? null : DisplayOrder;
      csletr.publish_date = PublishDate;

      //追加・変更内容をbodyへ格納
      let arrStr = [];
      arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr;

      if (select_que_id == -1) {
        //insert
        const res = await axios.post("/m_question/insert/auth", body);
        if (res.status !== 200) {
          console.log("保存処理終了(insert失敗)");
          setMsg("新規追加が失敗しました。もう一度入力してください。");
          return;
        } else {
          console.log("保存処理終了(insert成功)");
        }
      } else {
        //update
        const res = await axios.post("/m_question/update/auth", body);
        if (res.status !== 200) {
          console.log("保存処理終了(update失敗)");
          setMsg("編集が失敗しました。もう一度入力してください。");
          return
        } else {
          console.log("保存処理終了(update成功)");
        }
      }

      return window.location.href = './G0224QuestionList';
    } catch (e) {
      console.log("保存処理(例外発生)");
      console.log("error:", e.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //プレビュー画面遷移処理
  function preview() {
    //入力値チェック
    if (!ValueCheck()) {
      return
    };

    //window.open(別タブで開くため)とlocalStorageでのデータの受け渡し
    let questionDetail = {}
    questionDetail.preview = -1;
    questionDetail.contents_question = ContentsQuestion;
    questionDetail.question_answer = QuestionAnswer;
    questionDetail.publish_date = PublishDate;
    localStorage.setItem("preview", JSON.stringify({ questionDetail }))
    window.open('./D00502QuestionDetail', "preview")
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">
                <Stack spacing={2}>
                  <h1>{QueMain}</h1>

                  <TextField required id="publish_date"
                    value={PublishDate ?? ''}
                    label="公開日時"
                    type={'datetime-local'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={PublishDateMsg}
                    error={Boolean(PublishDateMsg == "" ? false : true)}
                    onChange={e => { setPublishDate(e.target.value) }}
                  />

                  {select_que_id !== -1 ? (                                 //変更時のみ表示
                    <TextField id="question_id"
                      value={QuestionId ?? ''}
                      label="質問ID"
                      error={Boolean(QuestionIdMsg == "" ? false : true)}
                      helperText={QuestionIdMsg}
                      onChange={e => { setQuestionId(e.target.value) }}
                      disabled={true}
                    />
                  ) : (null)}


                  <TextField required id="category_id" variant="outlined"
                    value={QuestionCategoryId ?? ''}
                    label="質問カテゴリーID"
                    error={Boolean(QuestionCategoryIdMsg == "" ? false : true)}
                    helperText={QuestionCategoryIdMsg}
                    onChange={e => { setQuestionCategoryId(e.target.value) }}
                    select
                  >
                    {QuestionCategoryList.map((option) => (
                      <MenuItem key={option.category_id} value={option.category_id}>
                        {option.category_name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField required id="contents_question"
                    value={ContentsQuestion}
                    label="質問内容"
                    error={Boolean(ContentsQuestionMsg == "" ? false : true)}
                    helperText={ContentsQuestionMsg}
                    onChange={e => setContentsQuestion(e.target.value)}
                  />

                  <TextField required id="question_answer"
                    value={QuestionAnswer}
                    label="質問回答"
                    error={Boolean(QuestionAnswerMsg == "" ? false : true)}
                    helperText={QuestionAnswerMsg}
                    onChange={e => setQuestionAnswer(e.target.value)}
                    multiline
                    rows={15}
                  />

                  <TextField id="display_order"
                    value={DisplayOrder}
                    label="表示順"
                    error={Boolean(DisplayOrderMsg == "" ? false : true)}
                    helperText={DisplayOrderMsg}
                    onChange={(e) => {
                      if (e.target.value.length <= 9) {
                        setDisplayOrder(e.target.value)
                      }
                    }}
                  />

                  <Stack spacing={2} direction="row">
                    <Button component={Link} to={"/G0224QuestionList"}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>

                    <Button onClick={register}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      保存
                    </Button>

                    <Button onClick={preview}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      プレビュー
                    </Button>
                  </Stack>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default G0225QuestionEdit;